// `react-router/dom` wires in `ReactDOM.flushSync`, which the `flushSync` navigate option needs.
import { RouterProvider } from 'react-router/dom';

import { AuthProvider } from '../auth/auth-provider';
import { ThemeProvider } from '../theme/theme-provider';
import { router } from './router';

/**
 * Application root.
 *
 * `AuthProvider` sits above the router so route guards and the shell can read the
 * session. It owns exactly one piece of state — who is signed in — and the
 * `AppShell` owns the rest, so the provider is not a state-management layer.
 * `ThemeProvider` wraps both so every screen, signed in or not, uses one theme.
 */
export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}
